import React, { useState } from 'react';
import { 
  FaQuoteLeft, 
  FaStar, 
  FaMapMarkerAlt, 
  FaUniversity,
  FaChevronLeft,
  FaChevronRight,
  FaGraduationCap,
  FaGlobeAfrica
} from 'react-icons/fa';
import './TestimonialsSection.css';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Chantal M.",
      origin: "Cameroun",
      city: "Lyon",
      school: "Université Lumière Lyon 2",
      program: "Master en Commerce International",
      text: "Grâce à BTG CONSEIL, j'ai intégré une école à Lyon et trouvé un logement en 10 jours. Leur accompagnement a été exceptionnel !",
      rating: 5,
      color: '#073b8f'
    },
    {
      id: 2,
      name: "Jean K.",
      origin: "Côte d'Ivoire",
      city: "Paris",
      school: "ESG Management School",
      program: "MBA en Finance",
      text: "BTG CONSEIL a rendu ma procédure simple et rapide. Mon visa a été obtenu en moins d'un mois grâce à leur expertise.",
      rating: 5,
      color: '#c0264a'
    },
    {
      id: 3,
      name: "Aïcha D.",
      origin: "Sénégal",
      city: "Toulouse",
      school: "INSA Toulouse",
      program: "Ingénieur en Informatique",
      text: "J'ai eu mon visa sans stress grâce à leur équipe. Leur accompagnement humain fait vraiment la différence.",
      rating: 5,
      color: '#073b8f'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <FaStar 
        key={index} 
        className={index < rating ? "btg-star btg-filled" : "btg-star"} 
      />
    ));
  };

  return (
    <section className="btg-testimonials-section-simple" id="btg-temoignages">
      <div className="btg-container-simple">
        {/* En-tête simplifié */}
        <div className="btg-testimonials-header-simple">
          <h2 className="btg-main-title-simple">Ils nous font confiance</h2>
          <p className="btg-subtitle-simple">
            Découvrez les expériences de nos étudiants
          </p>
        </div>

        {/* Carousel simplifié */}
        <div className="btg-testimonials-carousel-simple">
          <div className="btg-carousel-container-simple">
            <button className="btg-carousel-btn-simple btg-prev-simple" onClick={prevTestimonial}>
              <FaChevronLeft />
            </button>

            <div 
              className="btg-testimonial-card-simple"
              style={{ '--btg-accent-color': testimonials[currentTestimonial].color }}
            >
              <div className="btg-quote-section-simple">
                <FaQuoteLeft className="btg-quote-icon-simple" />
                <p className="btg-testimonial-text-simple">
                  "{testimonials[currentTestimonial].text}"
                </p>
                
                <div className="btg-rating-simple">
                  {renderStars(testimonials[currentTestimonial].rating)}
                </div>
              </div>

              <div className="btg-student-info-simple">
                <div className="btg-student-header-simple">
                  <h4>{testimonials[currentTestimonial].name}</h4>
                  <div className="btg-student-origin-simple">
                    <FaGlobeAfrica />
                    {testimonials[currentTestimonial].origin}
                  </div>
                </div>
                
                <div className="btg-student-details-simple">
                  <div className="btg-detail-item-simple">
                    <FaMapMarkerAlt />
                    <span>{testimonials[currentTestimonial].city}</span>
                  </div>
                  <div className="btg-detail-item-simple">
                    <FaUniversity />
                    <span>{testimonials[currentTestimonial].school}</span>
                  </div>
                  <div className="btg-detail-item-simple">
                    <FaGraduationCap />
                    <span>{testimonials[currentTestimonial].program}</span>
                  </div>
                </div>
              </div>
            </div>

            <button className="btg-carousel-btn-simple btg-next-simple" onClick={nextTestimonial}>
              <FaChevronRight />
            </button>
          </div>

          {/* Indicateurs simplifiés */}
          <div className="btg-carousel-indicators-simple">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`btg-indicator-simple ${index === currentTestimonial ? 'btg-active-simple' : ''}`}
                onClick={() => goToTestimonial(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;